<div>
    <forge-scaffold>
        <div slot="body" class="dialog-content" style="max-height: 75vh;">
            @if (showBusyIndicator) {
            <div class="layout-row layout-align-space-around">
                <busy-indicator></busy-indicator>
            </div>
            }

            <form #form="ngForm">
                <metadata-view [ngModelGroup]="listenerId" [viewTitle]="title" [view]="view" [model]="model"
                    [datacontroller]="datacontroller" [viewOnly]="action.ViewOnly" [onDelete]="onDelete"
                    [(recalculating)]="viewRecalculating" [pageHeader]="false" [dialogIndex]="dialogIndex">
                </metadata-view>
            </form>
        </div>

        <forge-toolbar slot="footer" class="layout-row layout-align-end">
            <command-bar [commands]="commands" telemetry="title" slot="end" [useMouseDown]="true"></command-bar>
        </forge-toolbar>
    </forge-scaffold>
</div>